export class BusinessSettingsModel {
  static fromDTO(dto) {
    return new BusinessSettingsModel(dto.legalTermsDocumentId, dto.disablePlaidLink, dto.netTerms, dto.billingDayOfMonth, dto.billingDayOfWeek, dto.feeControls, dto.amendmentsApprovalMethod, dto.invoicesApprovalMethod, dto.billUpfront, dto.automaticServicesPausedByDefault, dto.prorateFirstInvoice, dto.requestAccountantAccess, dto.introductoryMessages, dto.startBillingOn, dto.introVideo, dto.invoiceLineItems, dto.expirationDate, dto.invoicePrefix);
  }
  constructor(legalTermsDocumentId, disablePlaidLink, netTerms, billingDayOfMonth, billingDayOfWeek, feeControls, amendmentsApprovalMethod, invoicesApprovalMethod, billUpfront, automaticServicesPausedByDefault, prorateFirstInvoice, requestAccountantAccess, introductoryMessages, startBillingOn, introVideo, invoiceLineItems, expirationDate, invoicePrefix) {
    this.legalTermsDocumentId = legalTermsDocumentId;
    this.disablePlaidLink = disablePlaidLink;
    this.netTerms = netTerms;
    this.billingDayOfMonth = billingDayOfMonth;
    this.billingDayOfWeek = billingDayOfWeek;
    this.feeControls = feeControls;
    this.amendmentsApprovalMethod = amendmentsApprovalMethod;
    this.invoicesApprovalMethod = invoicesApprovalMethod;
    this.billUpfront = billUpfront;
    this.automaticServicesPausedByDefault = automaticServicesPausedByDefault;
    this.prorateFirstInvoice = prorateFirstInvoice;
    this.requestAccountantAccess = requestAccountantAccess;
    this.introductoryMessages = introductoryMessages;
    this.startBillingOn = startBillingOn;
    this.introVideo = introVideo;
    this.invoiceLineItems = invoiceLineItems;
    this.expirationDate = expirationDate;
    this.invoicePrefix = invoicePrefix;
  }
}